module.exports = __webpack_public_path__ + "img/Home Page banner (Website).d5fe208f.svg";